import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	Row,
	Col,
	notification,
	Modal,
	Tag,
} from "antd";
import Layout from "../layout/Layout";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import {
	EyeOutlined,
	EditOutlined,
	PlusCircleOutlined,
} from "@ant-design/icons";
import { useRef } from "react";
import PreJobInView from "./PreJobInView";
import PreJobToJob from "./PreJobToJob";
const { Text } = Typography;

const PreJobDashboard = () => {
	const [loading, setLoading] = useState(true);
	const [preJobList, setPreJobList] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [sellers, setSellers] = useState([]);
	const [seller, setSeller] = useState(null);
	const [apiNotification, contextHolder] = notification.useNotification();
	const currentPREJobId = useRef(null);
	const [modalViewOpen, setModalViewOpen] = useState(false);
	const [modalCreateOpen, setModalCreateOpen] = useState(false);
	const [isEdit, setIsEdit] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 50,
			render: (_, record) => {
				return (
					<Flex>
						{(localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "ec@57concrete.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "jc@57concrete.com" ||
							localStorage.getItem("email") === "gg@57xgroup.com" ||
							localStorage.getItem("email") === "bpa@57concrete.com" ||
							localStorage.getItem("email") === "jp@57concrete.com" ||
							localStorage.getItem("email") === "mgr@57concrete.com") && (
							<Button
								type="primary"
								danger
								icon={<EditOutlined twoToneColor={"white"} />}
								onClick={() => {
									currentPREJobId.current = record.id;
									setModalViewOpen(true);
									setIsEdit(true);
								}}
							/>
						)}
						&nbsp;
						<Button
							type="primary"
							icon={<EyeOutlined twoToneColor={"white"} />}
							onClick={() => {
								currentPREJobId.current = record.id;
								setModalViewOpen(true);
								setIsEdit(false);
							}}
						/>
						&nbsp;
						<Button
							type="primary"
							icon={<PlusCircleOutlined twoToneColor={"white"} />}
							disabled={record.type === "JOB"}
							onClick={() => {
								currentPREJobId.current = record.id;
								setModalCreateOpen(true);
							}}
						/>
					</Flex>
				);
			},
		},
		{
			title: "Date",
			dataIndex: "scheduledDate",
			key: "scheduledDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix",
			dataIndex: "mix",
			key: "mix",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Slump",
			dataIndex: "slump",
			key: "slump",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Target YD3",
			dataIndex: "targetYD3",
			key: "targetYD3",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "To Job Date",
			dataIndex: "toJobDate",
			key: "toJobDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Job Number",
			dataIndex: "jobNumber",
			key: "jobNumber",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
			render: (value) => {
				return <Tag color={value === "PRE" ? "blue" : "green"}>{value}</Tag>;
			},
		},
	];

	useEffect(() => {
		getSellers();
		getPREJobs("");
	}, []);

	const getPREJobs = async (term) => {
		setLoading(true);

		let query = "";

		const email = localStorage.getItem("email");

		if (
			email === "eliud@gmail.com" ||
			email === "ec@57concrete.com" ||
			email === "pc@57concrete.com" ||
			email === "jc@57concrete.com" ||
			email === "gg@57xgroup.com" ||
			email === "bpa@57concrete.com" ||
			email === "jp@57concrete.com" ||
			email === "mgr@57concrete.com"
		) {
			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			query = `?startDate=${start}&endDate=${end}&term=${term}&seller=${seller}&isSeller=${false}`;
		} else if (localStorage.getItem("role") === "Seller") {
			query = `?seller=${localStorage.getItem("userId")}&isSeller=${true}`;
		}

		const url = api + `/prejob/list${query}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (data.success) {
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						scheduledDate: dayjs(item.scheduledDate).format(
							"MM/DD/YYYY HH:mm A",
						),
						customer: item.customer,
						mix: item.mix,
						slump: item.slump,
						targetYD3: item.targetYD3,
						plant: item.plant,
						toJobDate: item.toJobDate
							? dayjs(item.toJobDate).format("MM/DD/YYYY HH:mm A")
							: "N/A",
						type: item.type,
						jobNumber: item.job ? item.job.number : "N/A",
					});
				});
				setPreJobList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getSellers = async () => {
		const url = api + `/user/list/57Concrete/Seller`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const payload = data.payload;
				let list = [];
				payload.map((item) => {
					list.push({
						label: item.name,
						value: item._id,
					});
				});
				setSellers(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const onSearch = (value, _e, info) => {
		if (info?.source === "input") {
			getPREJobs(value);
		}
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onChangePicker = (value) => {
		setSeller(value);
	};

	const RenderSearch = () => {
		return (
			<CustomSearch
				startDate={startDate}
				endDate={endDate}
				dateFormat={"MM/DD/YYYY"}
				loading={loading}
				onRangeChange={onRangeChange}
				onSearch={onSearch}
				labelPicker={"seller"}
				optionsPicker={sellers}
				onChangePicker={onChangePicker}
				allowClearPicker={true}
				pickerValue={seller}
				pickerWidth={"200px"}
			/>
		);
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"}>
				<CustomTable columns={columns} data={preJobList} isScroll={false} />
			</Flex>
		);
	};

	const ModalView = () => {
		return (
			<Modal
				title={isEdit ? "Edit PRE Job" : "View PRE Job"}
				open={modalViewOpen}
				onCancel={() => setModalViewOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<PreJobInView preJobId={currentPREJobId.current} isEdit={isEdit} />
			</Modal>
		);
	};

	const closePreJob = async (jobId) => {
		const url = api + `/prejob/close/${currentPREJobId.current}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url, { job: jobId });

			if (data.success) {
				currentPREJobId.current = null;
				openNotification("success", "Success", "Job Created");
				getPREJobs("");
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const closeCreateModal = (jobId) => {
		setModalCreateOpen(false);
		closePreJob(jobId);
	};

	const ModalCreate = () => {
		return (
			<Modal
				title={"Create New Job"}
				open={modalCreateOpen}
				onCancel={() => setModalCreateOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<PreJobToJob
					preJobId={currentPREJobId.current}
					pcb={closeCreateModal}
				/>
			</Modal>
		);
	};

	return (
		<Layout title="PRE Job Dashboard" description="PRE Job">
			<Flex vertical gap={"large"}>
				<RenderSearch />
				{loading ? (
					<CustomSpinner />
				) : (
					<Row gutter={[16, 16]}>
						<Col span={24}>
							<RenderTable />
						</Col>
					</Row>
				)}
				{contextHolder}
				<ModalView />
				<ModalCreate />
			</Flex>
		</Layout>
	);
};

export default PreJobDashboard;
